import styled from "styled-components";
import style from "../../style";

const PageHeader = styled.div`
  font-size: 22px;
  line-height: 33px;
  font-weight: 600;
  color: ${style.mainText};
  margin-bottom: 20px;
  text-align: ${({ align }) => align};
`;

PageHeader.defaultProps = {
  align: "center",
};
export default PageHeader;
